const TopNav = ({ title, children }) => {
    return <div className="flex h-[3.25rem] items-center border-b border-l border-[#DCDEE4] bg-white px-4">{children}</div>;
};

export default TopNav;
